<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showModal" :data="model" :title="$t('Exchange Rates')" ref="artisioModal"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <div class="row">
        <div class="col-md-12 text-right">
          <b-button variant="link" class="pl-0 mb-2" @click="addNewTier">
            <font-awesome-icon :icon="'plus-circle'"/>
            {{ $t('Add New Rate') }}
          </b-button>
        </div>
      </div>
      <table v-if="model && model.currencyExchangeModels.length > 0">
        <tr>
          <th style="width: 50%">{{ $t('Currency') }}</th>
          <th style="width: 40%">{{ $t('Amount') }}</th>
          <th style="width: 10%">
          </th>
        </tr>
        <tr v-for="(exchangeModel, index) in model.currencyExchangeModels" :key="`currency-model-row-${index}`">
          <td class="pr-3">
            <currency-select-input-widget attribute="code" :model="exchangeModel" value-field="code" :label="false"/>
          </td>
          <td>
            <input-widget :model="exchangeModel" attribute="amount" :label="false" step="0.01" type="number"/>
          </td>
          <td class="d-flex align-items-center">
            <div style="flex: 1" class="text-center" v-if="index > 0">
              <b-tooltip :target="`remove-tier-button-${index}`" :title="$t('Delete')"/>
              <font-awesome-icon
                  tabindex="-1" class="text-danger hover-cursor" :id="`remove-tier-button-${index}`"
                  style="font-size: 1.5em;" icon="times" @click="removeTierByIndex(index)">
              </font-awesome-icon>
            </div>
          </td>
        </tr>
      </table>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CurrencyExchangeModel from "@/modules/sales/view/terms/modals/CurrencyExchangeModel";
  import CurrencySelectInputWidget from "@/core/widgets/CurrencySelectInputWidget";
  import InputWidget from "@/core/components/input-widget/InputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('sales');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CurrencyExchangesModal",
    components: {InputWidget, CurrencySelectInputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: {
          currencyExchangeModels: []
        },
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['toggleCurrencyExchangesModal', 'saveTermsPartialData']),
      async onSubmit() {
        let requestObj = {}
        this.model.currencyExchangeModels.forEach(m => requestObj[m.code] = m.amount)

        this.loading = true;
        let response = await this.saveTermsPartialData({currency_exchanges: requestObj});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleCurrencyExchangesModal({showModal: false});
          this.$toast('success', this.$t('Settlement days were successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.toggleCurrencyExchangesModal({showModal: false});
      },
      addNewTier() {
        this.model.currencyExchangeModels.push(new CurrencyExchangeModel())
      },
      removeTierByIndex(index) {
        for (let i = 0; i < this.model.currencyExchangeModels.length; i++) {
          if (i === index) {
            this.model.currencyExchangeModels.splice(i, 1);
            break;
          }
        }
      }
    },
    watch: {
      currencyExchanges() {
        this.model.currencyExchangeModels = []

        if (this.currencyExchanges && Object.keys(this.currencyExchanges).length > 0) {
          for (let code in this.currencyExchanges) {
            this.model.currencyExchangeModels.push(new CurrencyExchangeModel({
              amount: this.currencyExchanges[code],
              code
            }))
          }
        } else {
          this.model.currencyExchangeModels.push(new CurrencyExchangeModel())
        }

        if (this.$refs.artisioModal) {
          this.$refs.artisioModal.updateOldState()
        }
      }
    },
    computed: {
      ...mapState({
        showModal: state => state.view.termsData.currencyExchangesModal.show,
        currencyExchanges: state => state.view.termsData.currencyExchangesModal.currencyExchanges
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

